import { render } from "./LayoutSidebar.vue?vue&type=template&id=4ce93930"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__